const ws_mailer = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M21%203a2%202%200%200%201%202%202v14a2%202%200%200%201-2%202H3a2%202%200%200%201-2-2V5a2%202%200%200%201%202-2h18zm0%206.618l-9%204.5-9-4.5V19h18V9.618zM21%205H3v2.382l9%204.5%209-4.5V5z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  ws_mailer as default
};
//# sourceMappingURL=ws_mailer.svg.es.js.map
